module.exports = __webpack_public_path__ + "static/img/51-3.297b988.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/51-3.jpg
// module id = 10zj
// module chunks = 0